import { render, staticRenderFns } from "./ContentHeaderCustom.vue?vue&type=template&id=0964e44e&scoped=true"
import script from "./ContentHeaderCustom.vue?vue&type=script&lang=js"
export * from "./ContentHeaderCustom.vue?vue&type=script&lang=js"
import style0 from "./ContentHeaderCustom.vue?vue&type=style&index=0&id=0964e44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0964e44e",
  null
  
)

export default component.exports